/**
 * Subscription Packages Service
 * Handles fetching subscription packages from Supabase
 */

import type { SubscriptionPackageInfo } from '../types/subscription';
import { supabase } from './supabase';

export interface SubscriptionPackagesResponse {
  success: boolean;
  data?: SubscriptionPackageInfo[];
  error?: string;
}

/**
 * Fetch all active subscription packages
 */
export async function fetchSubscriptionPackages(): Promise<SubscriptionPackagesResponse> {
  try {
    const { data, error } = await supabase
      .from('subscription_packages')
      .select('*')
      .eq('is_active', true);

    if (error) {
      return {
        success: false,
        error: error.message || 'Failed to fetch subscription packages',
        data: [],
      };
    }

    return {
      success: true,
      data: data || [],
    };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to fetch subscription packages',
      data: [],
    };
  }
}
